<div class="card w-100" style="z-index: 1">
    <div class="card-body pb-0">
        <div class="row animated fadeIn">
            <div class="col-md-12">
                <div class="row justify-content-between align-items-center mb-2 zIndexUp">
                    <div class="col-auto">
                        <div>
                            <mat-form-field class="example-full-width pb-0 w-100 form-control-design1" appearance="fill"
                                style="width: 250px !important; float: right">
                                <input #inputField matInput class="text-limit pos-search" [(ngModel)]="searchword"
                                    placeholder="Search Financial Year" (keyup.enter)="applyFilter()" />
                                <span class="mdi mdi-magnify mdi-2x cursor-pointer" title="Search Financial Year" style="
                    position: absolute;
                    right: 0;
                    font-size: 20px;
                    color: #999;
                    top: 0;
                  " (click)="applyFilter()">
                                </span>
                                <span class="position-absolute"
                                    style="top: 50%; right: 7%; transform: translate(-50%, -50%)" title="Clear">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                        class="bi bi-x" viewBox="0 0 16 16" (click)="clearUserData(); applyFilter()"
                                        (clearEvent)="searchword = ''" *ngIf="searchword">
                                        <path
                                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </span>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-auto">
                        <ul
                            class="list-unstyled px-0 action-tool-bar col-xl-auto col-lg-auto col-md-10 col-sm-12 mb-0 d-flex align-items-center flex-wrap">
                            <li>
                                <a *ngIf="permission.SalesTarget_Add == 1 || roleId == 1" href="javascript:void(0);"
                                    (click)="show('0')" class="btn btn-sm btn-light-info" style="min-width: 130px">
                                    <span class="mdi mdi mdi-plus"></span> Add Sales Target
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body p-0">
                        <div class="table-responsive">
                            <table class="table table-mini-th" mat-table [dataSource]="dataSource"
                                [multiTemplateDataRows]="true" aria-hidden="true">
                                <ng-container matColumnDef="BussinessVertical">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12">
                                        Finc Yr
                                    </th>
                                    <div matColumnDef="Total">
                                        <td mat-header-cell *matHeaderCellDef [attr.colspan]="1"
                                            class="text-right ali font-w">
                                            Total
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <a href="javascript:void(0);" (click)="
                                        view(element.FinancialYear)
                      ">{{ element["FinancialYear"] }}
                                        </a>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="ProjectName">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-100-small">
                                        Total Sal Eng. Tr
                                    </th>
                                    <div matColumnDef="TotalValue">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalBookingTarget | number : "1.2-2"}}
                                            </span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalAchieved < TotalRow?.TotalBookingTarget ? 'red' : 'green'}">{{TotalRow?.TotalAchieved
                                                | number : "1.2-2"}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        {{ element["BookingTarget"] | number : "1.2-2"}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="InquiryName">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-90-small">
                                        Jan
                                    </th>
                                    <div matColumnDef="TotalJan">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalJanTarget | number : '1.2-2'}}</span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalJanAchieved < TotalRow?.TotalJanTarget ? 'red' : 'green'}">{{TotalRow?.TotalJanAchieved
                                                | number : '1.2-2'}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <span> {{ element["JanTarget"] | number : "1.2-2"}}</span><br>
                                        <span
                                            [ngStyle]="{'color': element.JanAchieved < element.JanTarget ? 'red' : 'green'}">{{
                                            element["JanAchieved"] | number : "1.2-2"}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="ReceivedDate">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-90-small">
                                        Feb
                                    </th>
                                    <div matColumnDef="TotalFeb">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalFebTarget | number : "1.2-2"}}
                                            </span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalFebAchieved < TotalRow?.TotalFebTarget ? 'red' : 'green'}">{{TotalRow?.TotalFebAchieved
                                                | number : "1.2-2"}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <span> {{ element["FebTarget"] | number : "1.2-2"}}</span><br>
                                        <span
                                            [ngStyle]="{'color': element.FebAchieved < element.FebTarget ? 'red' : 'green'}">{{
                                            element["FebAchieved"] | number : "1.2-2"}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="CustomerName">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-90-small">
                                        Mar
                                    </th>
                                    <div matColumnDef="TotalMar">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalMarTarget | number : "1.2-2"}}
                                            </span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalMarAchieved < TotalRow?.TotalMarTarget ? 'red' : 'green'}">{{TotalRow?.TotalMarAchieved
                                                | number : "1.2-2"}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <span> {{ element["MarTarget"] | number : "1.2-2"}}</span><br>
                                        <span
                                            [ngStyle]="{'color': element.MarAchieved < element.MarTarget ? 'red' : 'green'}">{{
                                            element["MarAchieved"] | number : "1.2-2"}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="InquiryProbability">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-90-small">
                                        Apr
                                    </th>
                                    <div matColumnDef="TotalApr">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalAprTarget | number : "1.2-2"}}
                                            </span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalAprAchieved < TotalRow?.TotalAprTarget ? 'red' : 'green'}">{{TotalRow?.TotalAprAchieved
                                                | number : "1.2-2"}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <span> {{ element["AprTarget"] | number : "1.2-2"}}</span><br>
                                        <span
                                            [ngStyle]="{'color': element.AprAchieved < element.AprTarget ? 'red' : 'green'}">{{
                                            element["AprAchieved"] | number : "1.2-2"}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Stage">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-90-small">
                                        May
                                    </th>
                                    <div matColumnDef="TotalMay">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalMayTarget | number : "1.2-2"}}
                                            </span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalMayAchieved < TotalRow?.TotalMayTarget ? 'red' : 'green'}">{{TotalRow?.TotalMayAchieved
                                                | number : "1.2-2"}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <span> {{ element["MayTarget"] | number : "1.2-2"}}</span><br>
                                        <span
                                            [ngStyle]="{'color': element.MayAchieved < element.MayTarget ? 'red' : 'green'}">{{
                                            element["MayAchieved"] | number : "1.2-2"}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="SalesEngineer">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-90-small">
                                        Jun
                                    </th>
                                    <div matColumnDef="TotalJun">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalJunTarget | number : "1.2-2"}}
                                            </span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalJunAchieved < TotalRow?.TotalJunTarget ? 'red' : 'green'}">{{TotalRow?.TotalJunAchieved
                                                | number : "1.2-2"}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <span> {{ element["JunTarget"] | number : "1.2-2"}}</span><br>
                                        <span
                                            [ngStyle]="{'color': element.JunAchieved < element.JunTarget ? 'red' : 'green'}">{{
                                            element["JunAchieved"] | number : "1.2-2"}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="QuotationEngineer">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-90-small">
                                        Jul
                                    </th>
                                    <div matColumnDef="TotalJul">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalJulTarget | number : "1.2-2"}}
                                            </span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalJulAchieved < TotalRow?.TotalJulTarget ? 'red' : 'green'}">{{TotalRow?.TotalJulAchieved
                                                | number : "1.2-2"}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <span>{{ element["JulTarget"] | number : "1.2-2"}}</span><br>
                                        <span
                                            [ngStyle]="{'color': element.JulAchieved < element.JulTarget ? 'red' : 'green'}">{{
                                            element["JulAchieved"] | number : "1.2-2"}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="QuotedValue">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-90-small">
                                        Aug
                                    </th>
                                    <div matColumnDef="TotalAug">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalAugTarget | number : "1.2-2"}}
                                            </span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalAugAchieved < TotalRow?.TotalAugTarget ? 'red' : 'green'}">{{TotalRow?.TotalAugAchieved
                                                | number : "1.2-2"}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <span> {{ element["AugTarget"] | number : "1.2-2"}}</span><br>
                                        <span
                                            [ngStyle]="{'color': element.AugAchieved < element.AugTarget ? 'red' : 'green'}">{{
                                            element["AugAchieved"] | number : "1.2-2"}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="ReportedValue">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-90-small">
                                        Sep
                                    </th>
                                    <div matColumnDef="TotalSep">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalSepTarget | number : "1.2-2"}}
                                            </span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalSepAchieved < TotalRow?.TotalSepTarget ? 'red' : 'green'}">{{TotalRow?.TotalSepAchieved
                                                | number : "1.2-2"}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <span>{{ element["SepTarget"] | number : "1.2-2"}}</span><br>
                                        <span
                                            [ngStyle]="{'color': element.SepAchieved < element.SepTarget ? 'red' : 'green'}">{{
                                            element["SepAchieved"] | number : "1.2-2"}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="ExpOrderDate">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-90-small">
                                        Oct
                                    </th>
                                    <div matColumnDef="TotalOct">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalOctTarget | number : "1.2-2"}}
                                            </span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalOctAchieved < TotalRow?.TotalOctTarget ? 'red' : 'green'}">{{TotalRow?.TotalOctAchieved
                                                | number : "1.2-2"}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <span> {{ element["OctTarget"] | number : "1.2-2"}}</span><br>
                                        <span
                                            [ngStyle]="{'color': element.OctAchieved < element.OctTarget ? 'red' : 'green'}">{{
                                            element["OctAchieved"] | number : "1.2-2"}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Nov">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-90-small">
                                        Nov
                                    </th>
                                    <div matColumnDef="TotalNov">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalNovTarget | number : "1.2-2"}}
                                            </span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalNovAchieved < TotalRow?.TotalNovTarget ? 'red' : 'green'}">{{TotalRow?.TotalNovAchieved
                                                | number : "1.2-2"}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <span>{{ element["NovTarget"] | number : "1.2-2"}}</span><br>
                                        <span
                                            [ngStyle]="{'color': element.NovAchieved < element.NovTarget ? 'red' : 'green'}">{{
                                            element["NovAchieved"] | number : "1.2-2"}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Dec">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12 width-90-small">
                                        Dec
                                    </th>
                                    <div matColumnDef="TotalDec">
                                        <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                            <span>{{TotalRow?.TotalDecTarget | number : "1.2-2"}}
                                            </span><br>
                                            <span
                                                [ngStyle]="{'color': TotalRow?.TotalDecAchieved < TotalRow?.TotalDecTarget ? 'red' : 'green'}">{{TotalRow?.TotalDecAchieved
                                                | number : "1.2-2"}}</span>
                                        </td>
                                    </div>
                                    <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                        <span>{{ element["DecTarget"] | number : "1.2-2"}}</span><br>
                                        <span
                                            [ngStyle]="{'color': element.DecAchieved < element.DecTarget ? 'red' : 'green'}">{{
                                            element["DecAchieved"] | number : "1.2-2"}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="Action">
                                    <th mat-header-cell *matHeaderCellDef class="p-1 font-12">
                                        <span class="mdi mdi-settings"></span>
                                    </th>
                                    <td mat-cell *matCellDef="let element" class="p-1 font-12">
                                        <div ngbDropdown class="d-block list-dropdown-box" *ngIf="permission.SalesTarget_View==1 || roleId == 1">
                                            <a href="javascript:void(0);" class="text-center d-block"
                                                id="dropdownBasic1" ngbDropdownToggle>
                                                <i class="mdi mdi-dots-vertical mdi-24"></i></a>
                                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1"
                                                class="dropdown-menu-right">
                                                <div class="d-block">
                                                    <div *ngIf="permission.SalesTarget_View == 1 || roleId == 1">
                                                        <a href="javascript:void(0);" class="" placement="bottom"
                                                            (click)="view(element.FinancialYear)">
                                                            <button ngbDropdownItem>
                                                                <i class="mdi mdi-backup-restore"
                                                                    style="color: #da02ff"></i>
                                                                Detail
                                                            </button>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div *ngIf="permission.SalesTarget_Edit == 1 || roleId == 1">
                                                    <a href="javascript:void(0);" class="" placement="bottom"
                                                        ngbTooltip="Edit" (click)="edit(element.FinancialYear)"><button
                                                            ngbDropdownItem>
                                                            <i class="mdi mdi-pencil" style="color: green"></i>
                                                            Edit
                                                        </button>
                                                    </a>
                                                </div>
                                                <div class="d-block">
                                                    <div *ngIf="permission.SalesTarget_Export == 1 || roleId == 1">
                                                        <a href="javascript:void(0);" class="" placement="bottom"
                                                            (click)="ExportOpenModal(exportConfirm, element.FinancialYear)">
                                                            <button ngbDropdownItem>
                                                                <i class="mdi mdi-export" style="color: #1e90ff"></i>
                                                                Export
                                                            </button>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>

                                <tr class="odd" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr class="even" mat-header-row *matHeaderRowDef="displayedTotalColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                            </table>
                            <div *ngIf="TotalRecord == 0" class="text-center">
                                No Record found.
                            </div>
                            <div *ngIf="TotalRecord > 0">
                                <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]" [length]="totalSize"
                                    showFirstLastButtons aria-label="Select page of periodic elements"
                                    [pageIndex]="currentPage" (page)="handlePage($event)" [pageSize]="pageSize">
                                </mat-paginator>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Export-->
<ng-template #exportConfirm>
    <div class="modal-body text-center">
        <p>Do you want to export?</p>
        <button type="button" class="btn btn-info btn-sm" (click)="exportinquiry(); modalRef.hide()"
            [disabled]="exportName">
            Confirm
        </button>
        <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline(); modalRef.hide()">
            Cancel
        </button>
    </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>